export const PartsSupplierPartsDialogColumnsModel = [
  {
    label: 'Supplier Name',
    type: 'string',
    property: 'name',
    isVisible: true
  },
  {
    label: 'SKU',
    type: 'string',
    property: 'sku',
    isVisible: true,
    editable: 'true',
    inCellValidations: 'true',
    inCellValidationErrorMessages: {
      maxlength: 'Cannot be more than 20 characters'
    },
    inCellValidationErrors: {
      maxLength: 20
    },
    errorToolTipPosition: 'left'
  },
  {
    label: 'Cost',
    type: 'number',
    property: 'cost',
    isVisible: true,
    editable: 'true',
    inCellValidations: 'true',
    inCellValidationErrorMessages: {
      max: 'Please use number below 100,000,000.00',
      customError: 'Please use no more than two decimal points'
    },
    inCellValidationErrors: {
      max: 99999999.99,
      customError: true
    },
    errorToolTipPosition: 'left'
  }
];
